export default {
    getAllBrands: env => {
        return {
            url: `/${env}/brands`,
            method: 'GET',
        };
    },
    getBrandDetails: (env, brandId) => {
        return {
            url: `/${env}/brands/:brandId`,
            method: 'GET',
            route_params: {
                brandId,
            },
        };
    },
    updateBrandDetails: (env, brandId, form) => {
        let params = {};
        Object.keys(form).map(field => {
            if (form[field]) params[field] = form[field];
        });
        return {
            url: `/${env}/brands/:brandId`,
            method: 'PATCH',
            route_params: {
                brandId,
            },
            patch_params: params,
        };
    },
    addBrand: (env, brandForm) => {
        let params = {};
        Object.keys(brandForm).map(field => {
            if (brandForm[field]) params[field] = brandForm[field];
        });
        return {
            url: `/${env}/brands/add`,
            method: 'POST',
            post_params: params,
        };
    },
    deleteBrand: (env, brandId) => {
        return {
            url: `/${env}/brands/delete`,
            method: 'POST',
            post_params: {
                brandId,
            },
        };
    },
};



// WEBPACK FOOTER //
// ./environments/genericEnv/data/Brands/api.js